import { useContent } from "../app/ContentContext";
import { Box, Container } from "@mui/system";
import EmployeeCard from "./EmployeeCard";

function EmployeeList() {
  const { staff } = useContent();
  return (
    <Container sx={{ py: 4 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          gap: 4,
        }}
      >
        {staff.map((employee, index) => (
          <EmployeeCard
            key={index}
            name={employee.name}
            position={employee.position}
            description={employee.description}
            image={employee.image}
          />
        ))}
      </Box>
    </Container>
  );
}

export default EmployeeList;
